<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="3000014" />

    <section slot="titleRight">
      <qx-permpisions permpisions="1002060401">
        <el-button type="primary" plain @click="() => toEdit(null, 'add')">
          <i class="iconfont">&#xe6ab;</i>新增保养
        </el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            :fixed="item.prop === 'plateNumber'"
          >
            <section slot-scope="scope">

              <section
                v-if="scope.column.property === 'plateNumber'"
                @click="toCarDetail(scope.row)"
              >
                <span class="primary cur">
                  {{ scope.row[scope.column.property] }}
                </span>
              </section>
              <section v-else>
                <span>{{ scope.row[scope.column.property] }}</span>
              </section>
            </section>
          </el-table-column>
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="140"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :isCenter="true"
                :btnList="[
                  {
                    permpisions: '1002060402',
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row, 'edit'),
                  },

                  {
                    showCondition: true,
                    name: '查看',
                    event: () => toEdit(scope.row, 'detail'),
                  },
                  {
                    permpisions: '1002060403',
                    showCondition: true,
                    name: '删除',
                    event: () => toCancel(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.id),
                  },
                ]"
              />
            </template>
          </el-table-column>
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import {doDeleteVehicleMaintenanceRecord, getVehicleMaintenanceRecordList} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    TableBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { label: '车辆号码', prop: 'plateNumber' },
          { label: '保养日期', prop: 'maintenanceDate' },
          { label: '行驶里程（km）', prop: 'drivingDistanceDouble' },
          { label: '保养项目', prop: 'maintenanceProject' },
          { label: '金额', prop: 'amountDouble' },
          { label: '服务站点', prop: 'serviceSite' },
          { label: '服务商', prop: 'serviceName' },
          { label: '备注', prop: 'remark' },
          { label: '下次保养里程数（km）', prop: 'mileageForNextMaintenanceDouble' },
          { label: '下次保养日期', prop: 'nextMaintenanceDate' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: getVehicleMaintenanceRecordList,
    toCarDetail (item) {
      if (item.isDelete === 1) {
        this.$message({
          type: 'error',
          message: '该车辆已被删除！',
        });

      } else {
        const type = 'detail';
        this.jump({
          label: `查看车辆-${item.plateNumber}`,
          url: `/manage/car/archives/my/detailRecord?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass || ''}&type=${type}`,
          full: true,
        });
      }

    },
    async toCancel (item) {
      const confirmRes = await this.$confirm('是否确定删除该条保养记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        await doDeleteVehicleMaintenanceRecord({ id: item.id });
        this.getData();
      }
    },
    toEdit (item, type) {
      switch (type) {
        case 'add':
          this.jump({
            label: '新增保养记录',
            url: '/manage/car/maintain/maintenance/edit',
            full: true,
          });
          break;
        case 'detail':
          this.jump({
            label: `查看保养信息-${item.plateNumber}`,
            url: `/manage/car/maintain/maintenance/detail?id=${item.id}&type=detail`,
            full: true,
          });
          break;
        case 'edit':
          this.jump({
            label: '修改保养记录',
            url: `/manage/car/maintain/maintenance/edit?id=${item.id}`,
            full: true,
          });
          break;
        default:
          break;
      }
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
